module.exports = __webpack_public_path__ + "static/media/5.174901bd.png";